import React from "react";

import { Table } from "antd";

import styles from "./styles.module.css";
import QuantityComponent from "../../../../helper/ReusableComponents/QuantityComponent/QuantityComponent";
import { useStringLogic } from "../hooks";

const StringsComponent = ({ data, marginRate, errorMsg, onQtyChange }) => {
  const { strings, handleQtyChange } = useStringLogic(data, onQtyChange);

  const columns = [
    {
      title: "Strings",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Qty.",
      dataIndex: "value",
      key: "value",
      render: (text, record) => (
        <QuantityComponent
          id={record.positionId}
          bandType={record.type}
          name="strings"
          data={record}
          min={record.min}
          max={record.max}
          qty={record.default}
          handleQtyChange={handleQtyChange}
        />
      ),
    },
    {
      title: "Price",
      dataIndex: "totalPrice",
      key: "totalPrice",
      render: (text, record) => (
        <span>
          ${text}
        </span>
      ),
    },
    // {
    //   title: "Price",
    //   dataIndex: "rate",
    //   key: "rate",
    //   render: (text, record) => (
    //     <span>
    //       ${Math.round((record.default * text) / (1 - marginRate / 100))}
    //     </span>
    //   ),
    // },
  ];

  return (
    <>
      {errorMsg === "" ? (
        <div className={`row ${styles.string_content_tab} `}>
          <Table
            className="col-md-8"
            dataSource={strings}
            columns={columns}
            pagination={false}
          />
          <div className={`col-md-4 ${styles.band_config_string_table}`}>
            <div className={styles.string_img}>
              <img alt="Strings" src={"/assets/images/string.png"} />
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center h-100 mt-2">
          <p className="band-config-table-errMsg">
            Contact the team to add strings to your event
          </p>
        </div>
      )}
    </>
  );
};

export default StringsComponent;
